import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClientNote } from '../../models/client';
import { CompaniesService } from '../../services/companies.service';

@Component({
  selector: 'client-notes-modal',
  templateUrl: './client-notes-modal.component.html',
  standalone: false
})
export class ClientNotesModalComponent implements OnInit {
  @Input() public clientCode: string;
  public clientNote: ClientNote;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompaniesService
  ) {}

  ngOnInit(): void {
    // fetch active client note
    this.companyService.getActiveClientNote(this.clientCode).subscribe(note => {
      this.clientNote = note;
    });
  }
}
